(() => {
  if (window.fmProductGuideBooted) return;
  window.fmProductGuideBooted = true;
  const labels = {pet:{all:'All companions',large:'Medium & large dogs',small:'Small dogs',cat:'Cats'},format:{all:'Both formats',liquid:'Liquid',capsules:'Powder capsules'},range:{all:'Daily & PRO',daily:'Daily',pro:'PRO'}};
  function init(root) {
    if (root.dataset.guideReady) return;
    root.dataset.guideReady = 'true';
    const state = {pet:'all',format:'all',range:'all'};
    const rows = [...root.querySelectorAll('[data-companion]')];
    const summary = root.querySelector('[data-guide-summary]');
    function render() {
      const unique = new Set();
      rows.forEach(row => {
        const selected = state.pet === 'all' || state.pet === row.dataset.companion;
        let count = 0;
        row.querySelectorAll('[data-product]').forEach(card => {
          const matches = (state.format === 'all' || state.format === card.dataset.format) && (state.range === 'all' || state.range === card.dataset.range);
          card.hidden = !matches;
          if (matches) {count++; if (selected) unique.add(card.dataset.product);}
        });
        row.hidden = !selected || count === 0;
        row.querySelector('.product-group').dataset.count = String(count);
      });
      summary.replaceChildren();
      const strong = document.createElement('strong'); strong.textContent = labels.pet[state.pet]; summary.append(strong);
      summary.append(' / ' + labels.format[state.format] + ' / ' + labels.range[state.range] + ' · ' + unique.size + (unique.size === 1 ? ' product' : ' products'));
      root.querySelectorAll('fieldset[data-filter]').forEach(fieldset => fieldset.querySelectorAll('button[data-value]').forEach(button => button.setAttribute('aria-pressed',String(state[fieldset.dataset.filter] === button.dataset.value))));
    }
    root.addEventListener('click', event => {
      const choice = event.target.closest('button[data-value]');
      if (choice && root.contains(choice)) {
        const filter = choice.closest('fieldset[data-filter]').dataset.filter;
        state[filter] = choice.dataset.value; render(); return;
      }
      if (event.target.closest('[data-guide-reset]')) {state.pet=state.format=state.range='all';render();return;}
      const focus = event.target.closest('[data-focus-range]');
      if (focus) {state.range=focus.dataset.focusRange;render();root.querySelector('.finder').scrollIntoView({behavior:window.matchMedia('(prefers-reduced-motion: reduce)').matches?'auto':'smooth',block:'start'});}
    });
    render();
  }
  function boot() { document.querySelectorAll('[data-fm-product-guide]').forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded',boot,{once:true}); else boot();
  document.addEventListener('shopify:section:load',boot);
})();
